// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3sEUJ","error":"Textarea_error__3jF5j","readonly":"Textarea_readonly__2m8NJ","disabled":"Textarea_disabled__1v2-H"};